module.exports = __webpack_public_path__ + "static/media/banner.5041f9f7.svg";